import React from 'react'

import ContinueButton from 'components/ContinueButton'
import GoBackButton from './GoBackButton'

class ActionButtons extends React.Component {
  render() {
    let {
      onGoBackClick,
      onContinueClick,
      continueEnabled,
    } = this.props

    return(
      <div className="row justify-content-between">
        { onGoBackClick != null &&
          <div className="col" >
            <GoBackButton onClick={ onGoBackClick } />
          </div>
        }
        <div className="col text-right" >
          <div className="pull-right">
            <ContinueButton
              onClick={ onContinueClick }
              enabled={ continueEnabled }
            />
          </div>
          <div className="clearfix" />
        </div>
      </div>
    )
  }
}

export default ActionButtons
